var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents8" }, [
    _c("img", { staticClass: "bg", attrs: { src: _vm.bgImg } }),
    _vm._v(" "),
    _c("div", { staticClass: "contents" }, [
      _c("div", { staticClass: "text1" }, [
        _vm._v("\n      카랑의 서비스\n      "),
        !_vm.isMobile
          ? _c("div", { staticClass: "icon" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.prevBtn()
                    }
                  }
                },
                [_c("img", { attrs: { src: "static/img/arrow_left.png" } })]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.nextBtn()
                    }
                  }
                },
                [_c("img", { attrs: { src: "static/img/arrow_right.png" } })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-wrap", attrs: { id: "card-wrap" } },
        _vm._l(_vm.contents, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "card",
              attrs: { id: "card" + (index + 1) },
              on: {
                click: function($event) {
                  return _vm.getItem(index + 1)
                }
              }
            },
            [
              _c("div", { staticClass: "img" }, [
                _c("img", {
                  attrs: {
                    src: _vm.brandImg + (index + 1) + ".png",
                    width: "100%",
                    height: "100%"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("img", {
                  attrs: {
                    src: _vm.textImg + (index + 1) + ".png",
                    width: "100%",
                    height: "100%"
                  }
                })
              ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-338c3ac6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-338c3ac6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/main/Contents8.vue
// module id = null
// module chunks = 